import { FC } from 'react'
import { useNavigate } from 'react-router'
import { Button, ButtonFunction, ButtonType, ContextTile, ContextTileVariant } from '@enbw/ui-react'

type ErrorStateProps = {
  title: string
  description: string
  buttonLabel?: string
  href?: string
}

export const ErrorState: FC<ErrorStateProps> = ({ title, description, buttonLabel, href }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(href!)
  }

  return (
    <ContextTile title={title} description={description} variant={ContextTileVariant.BrandSecondary5}>
      {buttonLabel && (
        <Button slot="actions" type={ButtonType.Button} function={ButtonFunction.DangerPrimary} onClick={handleClick}>
          <span slot="label">{buttonLabel}</span>
        </Button>
      )}
    </ContextTile>
  )
}
